import React from 'react';
const v = require('voca');
const showdown = require('showdown');

export const labelForSeparator = (separator) => {
  switch (separator) {
    case ' ':
      return `Space ( )`;
    case ',':
      return `Comma (,)`;
    case ';':
      return `Semi-colon (;)`;
    case ':':
      return `Colon (:)`;
    case '|':
      return `Pipe (|)`;
    case '||':
      return `Double Pipe (||)`;
  }
};

export const string_data = [
  {
    name: 'CAPITALIZE',
    args: [
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'subject',
        label: 'Subject',
        value: '',
        hint: 'Choose field from collection (only string type is allowed)',
      },
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'restToLower',
        label: 'Rest To Lower',
        options: ['TRUE', 'FALSE'],
        hint: 'Convert the rest of subject to lower case',
      },
    ],
    allowedTypes: ['text', 'large_text', 'createdBy'],
  },
  {
    name: 'STRING_JOIN',
    args: [
      {
        minArgCount: 2,
        maxArgCount: 1,
        name: 'textFields',
        label: 'Args',
        value: '',
        hint: 'Choose fields from collection (only string type is allowed)',
      },
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'startString',
        label: 'Start String',
        external: true,
        value: '',
        hint: 'This text will be appened to starting.',
      },
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'endString',
        label: 'End String',
        external: true,
        value: '',
        hint: 'This text will be appened to ending.',
      },
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'separator',
        label: 'Separator',
        external: true,
        value: '',
        hint: 'A string to separate each pair of adjacent elements of the array.',
      },
    ],
    allowedTypes: ['text', 'large_text'],
  },
  {
    name: 'LOWER_CASE',
    args: [
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'subject',
        label: 'Subject',
        value: '',
        hint: 'Choose field from collection (only string type is allowed)',
      },
    ],
    allowedTypes: ['text', 'large_text', 'createdBy'],
  },
  {
    name: 'UPPER_CASE',
    args: [
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'subject',
        label: 'Subject',
        value: '',
        hint: 'Choose field from collection (only string type is allowed)',
      },
    ],
    allowedTypes: ['text', 'large_text', 'createdBy'],
  },
  {
    name: 'SLUGIFY',
    args: [
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'subject',
        label: 'Subject',
        value: '',
        hint: 'Choose field from collection (only string type is allowed)',
      },
    ],
    allowedTypes: ['text', 'large_text', 'createdBy'],
  },
  {
    name: 'TRIM',
    args: [
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'subject',
        label: 'Subject',
        value: '',
        hint: 'Choose field from collection (only string type is allowed)',
      },
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'whitespace',
        label: 'Whitespace',
        external: true,
        value: '',
        hint: 'The characters to trim. If want only spaces to trim leave empty.',
      },
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'type',
        label: 'Type',
        value: '',
        hint: 'From left/right/both side',
        options: ['LEFT', 'RIGHT', 'BOTH'],
      },
    ],
    allowedTypes: ['text', 'large_text', 'createdBy'],
  },
  {
    name: 'TITLE_CASE',
    args: [
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'subject',
        label: 'Subject',
        value: '',
        hint: 'Choose field from collection (only string type is allowed)',
      },
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'noSplitopt',
        label: 'No Split',
        external: true,
        value: '',
        hint: 'Do not split words at the specified characters.',
      },
    ],
    allowedTypes: ['text', 'large_text', 'createdBy'],
  },
  {
    name: 'TRUNCATE',
    args: [
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'subject',
        label: 'Subject',
        value: '',
        hint: 'Choose field from collection (only string type is allowed)',
      },
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'length',
        label: 'Length',
        external: true,
        value: '',
        hint: 'The length to truncate the string.',
      },
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'endopt',
        label: 'End Option',
        external: true,
        value: '',
        hint: 'The string to be added at the end.',
      },
    ],
    allowedTypes: ['text', 'large_text', 'createdBy'],
  },
  {
    name: 'SUB_STRING',
    args: [
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'subject',
        label: 'Subject',
        value: '',
        hint: 'Choose field from collection (only string type is allowed)',
      },
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'startLength',
        label: 'Start',
        external: true,
        value: '',
        hint: 'The position to start extraction.',
      },
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'endLength',
        label: 'Length',
        external: true,
        value: '',
        hint: 'The number of characters to extract.',
      },
    ],
    allowedTypes: ['text', 'large_text', 'createdBy'],
  },
  {
    name: 'CUSTOM_SENTENCE',
    args: [
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'expression',
        label: 'Custom Sentence',
        value: '',
        external: true,
      },
    ],
  },
  {
    name: 'BEAUTIFY_LIST',
    args: [
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'subject',
        label: 'Subject',
        value: '',
        hint: 'Choose field from collection (only static and dynamic option are allowed)',
      },
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'positionOfRecords',
        label: 'Position Of Records',
        value: '',
        options: ['FIRST', 'LAST'],
        hint: 'Position of the Records',
      },
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'numberOfRecords',
        label: 'Number of Records',
        external: true,
        value: '',
        hint: 'Number of records to get',
      },
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'elementToRender',
        label: 'Element to Render',
        value: '',
        options: ['BADGES', 'ORDERED_LIST', 'UNORDERED_LIST'],
        hint: 'Element to render the list',
      },
    ],
    allowedTypes: ['static_option', 'dynamic_option'],
  },
  {
    name: 'SPLIT_STRING',
    args: [
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'subject',
        label: 'Subject',
        placeholder: 'Select Field',
        value: '',
        hint: 'Choose field from collection (only string type is allowed)',
      },

      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'separator',
        label: 'Separator',
        placeholder: 'Select Separator',
        options: [' ', ',', ';', ':', '|', '||'],
        value: '',
        hint: 'A string to separate each pair of adjacent elements of the array.',
      },
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'index',
        label: 'Index',
        placeholder: 'Select Item Position',
        value: '',
        options: ['FIRST_ITEM', 'LAST_ITEM', 'NTH_ITEM'],
        hint: 'Part of split string.',
      },
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'indexNum',
        external: true,
        label: 'Index (Value of N)',
        value: '',
        hint: 'Value of N',
      },
    ],
    allowedTypes: ['text', 'large_text'],
  },
  {
    name: 'URL_PARAMETERS',
    args: [
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'type',
        label: 'Type',
        placeholder: 'Select Type of Field',
        value: '',
        options: ['ALL_FIELDS', 'JSON_FIELDS'],
        hint: 'Type of field to be selected.',
      },
      {
        minArgCount: 2,
        maxArgCount: 1,
        name: 'field',
        label: 'Field',
        placeholder: 'Select Field',
        value: '',
        hint: 'Choose field from collection',
      },
    ],
    allowedTypes: ['text', 'number', 'json'],
  },
  {
    name: 'MARKDOWN_TO_HTML',
    args: [
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'subject',
        label: 'Subject',
        value: '',
        hint: 'Choose field from collection',
      },
    ],
    allowedTypes: ['markdown'],
  },
  {
    name: 'TABLE_FORMAT',
    args: [
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'subject',
        label: 'Subject',
        value: '',
        hint: 'Choose field from collection(only reference field is allowed)',
      },
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'tableRefernceFields',
        label: 'Reference Fields',
        value: '',
        hint: 'Choose field from collection.',
      },
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'tableStyle',
        label: 'Table Style',
        external: true,
        value: 'Css Style to apply to table element',
        hint: 'Css Style to apply to table element',
      },
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'theadStyle',
        label: 'Table Head (thead) Style',
        external: true,
        value: 'Css Style to apply to table head element',
        hint: 'Css Style to apply to table head element',
      },
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'tbodyStyle',
        label: 'Table Body (tbody) Style',
        external: true,
        value: 'Css Style to apply to table body element',
        hint: 'Css Style to apply to table body element',
      },
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'trStyle',
        label: 'Table Row (tr) Style',
        external: true,
        value: 'Css Style to apply to table row element',
        hint: 'Css Style to apply to table row element',
      },
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'thStyle',
        label: 'Table head Cell (th) Style',
        external: true,
        value: 'Css Style to apply to td element',
        hint: 'Css Style to apply to td element',
      },
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'tdStyle',
        label: 'Table Data Cell (td) Style',
        external: true,
        value: 'Css Style to apply to td element',
        hint: 'Css Style to apply to td element',
      },
    ],
    allowedTypes: ['reference'],
  },
];

// String Operations
export const CAPITALIZE = (subject, restToLower) => v.capitalize(subject, restToLower);
export const LOWER_CASE = (subject) => v.lowerCase(subject);
export const UPPER_CASE = (subject) => v.upperCase(subject);
export const SLUGIFY = (subject) => v.slugify(subject);
export const TRIM = (subject, whitespace, type) => {
  if (type === 'left') {
    return v.trimLeft(subject, whitespace);
  } else if (type === 'right') {
    return v.trimRight(subject, whitespace);
  } else {
    return v.trim(subject, whitespace);
  }
};
export const TITLE_CASE = (subject, noSplitopt) => v.titleCase(subject, noSplitopt);
export const TRUNCATE = (subject, length, endopt) => v.truncate(subject, length, endopt);
export const SUB_STRING = (subject, startLength, endLength) =>
  v.substr(subject, startLength, endLength);

export const STRING_JOIN = (subject, seprator) => subject.join(seprator);
export const CUSTOM_SENTENCE = 'CUSTOM_SENTENCE';
export const BEAUTIFY_LIST = (subject, positionOfRecords, numberOfRecords) => {
  if (positionOfRecords === 'FIRST') return subject.slice(0, numberOfRecords);
  if (positionOfRecords === 'LAST') return subject.slice(-numberOfRecords);
};

export const SPLIT_STRING = (subject, separator, index, indexNum) => {
  separator = separator ? separator.replace(/##@@##@@##/g, ' ') : ' ';
  const stringArr = subject.split(separator);
  if (index === 'FIRST_ITEM') {
    indexNum = 0;
  } else if (index === 'LAST_ITEM') {
    indexNum = stringArr.length - 1;
  } else if (index === 'NTH_ITEM') {
    indexNum = indexNum - 1;
  }
  return stringArr[indexNum];
};

export const URL_PARAMETERS = () => {};

export const MARKDOWN_TO_HTML = (subject) => {
  const converter = new showdown.Converter({ tables: true });
  const html = converter.makeHtml(subject);
  return html;
};

export const TABLE_FORMAT = (tableRefernceFields) => {
  if (tableRefernceFields.length === 0) return '';
  return (
    <table className="table table-bordered">
      <thead>
        <tr>
          <td>Header</td>
          <td>Fields</td>
        </tr>
      </thead>
      <tbody>
        {tableRefernceFields.map(({ field, header }) => (
          <tr>
            <td>{header}</td>
            <td>{field}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
